import React, { useState } from "react";
import "./about.css";
import AboutPic from "../../assets/about.jpg";
import { FaFacebookF, FaGithub, FaInstagram } from "react-icons/fa";
import { BiMinus, BiPlus } from "react-icons/bi";
const About = () => {
  const [details, setDetails] = useState(true);

  return (
    <div className="aboutContainer">
      <div className="imageContainer">
        <div className={details ? "imageCard" : "imageCard2"}>
          <div className="imgBox">
            <img src={AboutPic} alt="about" className="aboutImage" />
            <button
              className={details ? "showHide Open" : "showHide Close"}
              onClick={() => setDetails(!details)}
            >
              {details ? <BiPlus /> : <BiMinus />}
            </button>
          </div>
          <div className={details ? "imgContent" : "imgContent2"}>
            <h2>Nikesh Pyakurel</h2>
            <h3 className="webColor">Web Developer</h3>
            <table>
              <tbody>

              <tr>
                <td>
                  <span className="que">Age</span>
                </td>
                <td>
                  <span className="ans">19</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="que">Address</span>
                </td>
                <td>
                  <span className="ans">Biratnagar-5,Morang</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="que">Email</span>
                </td>
                <td>
                  <span className="ans">nikeshjava28@gmail.com</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="que">Country</span>
                </td>
                <td>
                  <span className="ans">Nepal</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="que">Phone</span>
                </td>
                <td>
                  <span className="ans">+977-9863015479</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="que">Fiverr</span>
                </td>
                <td>
                  <span className="ans">nikeshpyakurel</span>
                </td>
              </tr>
              </tbody>
            </table>
            <div className="socialButtons">
              <button>
                <a href="hhttps://www.facebook.com/nikeshpyaku">
                  <FaFacebookF />
                </a>
              </button>
              <button>
                <a href="https://github.com/nikeshpyakurel/">
                  <FaGithub />
                </a>
              </button>
              <button>
                <a href="https://www.instagram.com/nikesh.pyakurel/">
                  <FaInstagram />
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="contentContainer">
        <h2 className="aboutHeading">About Me</h2>
        <div className="titleUnderline"></div>
        <h3 className="aboutHeading2">I'm In The Web Development Since 2019</h3>
        <p>
          I am a frontend web developer as well as WordPress Developer. I started
          my web development journey by learning frontend technologies like
          HTML, CSS, and JavaScript. From there I gradually improved my skills
          by building projects. way.
        </p>
        <p>
          I enjoy exploring new technologies, and developing projects that can
          impact and benefit people in a positive My Web developing career
          stared form 2019, when I finall got an chance to work as web developer
          in Ditial Pravidhi.
        </p>
        <h3 className="webColor" style={{ fontSize: "22px", fontWeight: 400 }}>
          Nikesh Pyakurel
        </h3>
        <h2 style={{ fontWeight: 200, fontSize: "18px", color: "grey" }}>
          Web Developer
        </h2>
        <div className="aboutBtnGroup">
          <button className="btn1">
            <a href="#home" src="download cv">
              {" "}
              Download CV
            </a>
          </button>
          <button className="btn2">
            <a href="https://www.fiverr.com/nikeshpyakurel" src="hire me">
              {" "}
              Hire Me
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
